<script>
import { videoComputed, videoMethods, workoutComputed, workoutMethods } from '@state/helpers';
import { breakpointsMixin } from '@mixins/breakpointsMixin';

export default {
  components: {},
  mixins: [breakpointsMixin],
  props: {
    videoUrl: {
      type: String,
      required: true,
      default: '',
    },
    coverPhotoUrl: {
      type: String,
      required: true,
      default: '',
    },
    setAutoplay: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      currentVideo: null,
    };
  },
  computed: {
    ...videoComputed,
    ...workoutComputed,
  },
  mounted() {
    if (this.$refs.videoBackground) {
      this.currentVideo = this.$refs.videoBackground.$el.firstElementChild.firstElementChild;
      if (this.currentVideo) {
        this.updateRemainingTime();
      }
    }
  },
  methods: {
    ...workoutMethods,
    ...videoMethods,
    updateRemainingTime() {
      this.currentVideo.ontimeupdate = () => {
        this.setRemainingVideoTime(Math.round(this.currentVideo.duration - this.currentVideo.currentTime));
        this.setVideoDuration(Math.round(this.currentVideo.duration));
        this.setCurrentVideoTime(Math.round(this.currentVideo.currentTime));
      };
    },
  },
  watch: {
    videoAction(newVal, oldVal) {
      switch (newVal) {
        case 'play':
          this.$refs.videoBackground.player.play();
          break;
        case 'pause':
          this.$refs.videoBackground.player.pause();
          break;
      }
    },
  },
};
</script>

<template>
  <video-background
    :style="{ height: $_isDesktopView() ? '100vh' : '60vh' }"
    ref="videoBackground"
    :src="videoUrl"
    :poster="coverPhotoUrl"
    :autoplay="setAutoplay"
    :muted="false"
  >
    <slot />
  </video-background>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
